<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>content_paste</md-icon>
          </div>
          <h4 class="title">
            Reports
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout" style="padding-top:30px;">
            <div class="md-layout-item md-size-20">
              <md-datepicker v-model="startDate" :md-model-type="String">
                <label>Start Date</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item md-size-20">
              <md-datepicker v-model="endDate" :md-model-type="String">
                <label>End Date</label>
              </md-datepicker>
            </div>
          </div>

          <!-- <div class="md-layout" style="padding-top:30px;">
            <div class="md-layout-item md-size-100">
              <date-picker v-model="dateRange" range placeholder="Select Date Range">
                <template v-slot:footer="{ emit }">
                  <div style="text-align: left">
                    <button class="mx-btn mx-btn-text" @click="selectNextThreeDay(emit)">
                      NextThreeDay
                    </button>
                  </div>
                </template>
              </date-picker>
            </div>
          </div> -->

          <report-toolbar :buttons="buttons" @showReport="showReport" />

          <div class="md-layout" id="date-header">
            <div class="md-layout-item md-size-100">
              <h3>{{ startDate | formatDate }} - {{ endDate | formatDate }}</h3>
            </div>
          </div>

          <component
            ref="reportView"
            :is="currentReport"
            :startDate="startDate"
            :endDate="endDate"
          ></component>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
// import 'vue2-datepicker/index.css';
import moment from "moment";
import ReportToolbar from "@/pages/Reporting/ReportToolbar";

const ReportSales = () => import("@/pages/Reporting/ReportSales");
const ReportDepartures = () => import("@/pages/Reporting/ReportDepartures");
const ReportOverdue = () => import("@/pages/Reporting/ReportOverdue");
const ReportAbtot = () => import("@/pages/Reporting/ReportAbtot");

export default {
  data() {
    return {
      report: null,
      buttons: [
        { desc: "Sales Report", component: "sales" },
        { desc: "Departures Report", component: "departures" },
        { desc: "Overdue Report", component: "overdue" },
        { desc: "ABTOT", component: "abtot" }
      ],
      startDate: "",
      endDate: "",
      dateRange: null
    };
  },

  components: {
    ReportToolbar
  },

  computed: {
    currentReport: function() {
      switch (this.report) {
        case "sales":
          return ReportSales;
          break;
        case "departures":
          return ReportDepartures;
          break;
        case "overdue":
          return ReportOverdue;
          break;
        case "abtot":
          return ReportAbtot;
          break;
        default:
          return null;
      }
    }
  },

  methods: {
    showReport(report) {
      this.report = report;
    }
  },

  mounted() {
    this.startDate = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.endDate = moment()
      .endOf("month")
      .format("YYYY-MM-DD");
  }
};
</script>
<style lang="scss" scoped>
#date-header {
  border-bottom: 2px solid grey;
}
</style>
